import { Col, Row } from "react-bootstrap";
import AdminLayout from "./layout/AdminLayout";
import ReportTimeList from "../components/admin/report/ReportTImeList";
const ReportTimeSetup = () => {
  return (
    <AdminLayout>
      <Row>
        <Col className="container mb-4">
          <ReportTimeList />
        </Col>
      </Row>
    </AdminLayout>
  );
};

export default ReportTimeSetup;
